<template lang="pug">
  div
    //- h3 Tipo Descuento
    v-radio-group.ml-3(v-if="allowDiscountType" v-model='discountTypeRadio' row='' )
      v-radio(label='Monto' value='price')
      v-radio(label='Porcentaje' value='percentage')
    ModelForm(
        ref="form"
        reset-text="limpiar"
        submit-text="Agregar a Descuento"
        title=""
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
    ModelForm(
        ref="formTable"
        reset-text="limpiar"
        submit-text="Guardar Esquema"
        title="Agregados"
        :fields="formFieldsTable"
        v-model="formDataTable"
        @reset="resetForm2"
        @submit="submitWholeSale"
        @removed="removedSaleDiscountTable($event)"  
        )
      template(slot="append")

        LoadingDialog.ml-4.mr-4.loadingClass(:loading="loading" )
      //- template(v-slot:header-actions)
      //-   span hola
</template>

<script>
import BranchOfficeService from '@/services/api/branchOffice'
import {ModelForm} from '@/components/reusable_components/next'
import fields from './fieldsMount'
import fieldsPercentage from './fieldsPercentage'
import fieldsTable from './fieldsTable'
import { nullableTypeAnnotation } from 'babel-types'
/* component */
import LoadingDialog from '@/components/reusable_components/LoadingDialog/LoadingDialog'
/* models */
import SlWholesaleDiscount from '@/models/Sale/SlWholesaleDiscount'
/* vuex */
import {mapActions} from 'vuex'
/* mixin */
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
/* axios */
import axios from 'axios'
export default {
  name: 'WholeSaleDiscount',
  props: {
    product:{
      type: Object,
      required: true,
    },
  },
  data: function(){
    return {
      formFields: null,
      formData : {},
      discountTypeRadio: 'price',
      formFieldsTable : null,
      formDataTable:{
        whole_sale_selected:[]
      },
      branchAvailable:[],
      allowDiscountType:true,
      loading: false,
    }
  },
  //computed: {},
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    // -- Validations and Error handling
    submit(event){
      let prices = this.getBranchPrices(event.branch_office_id)
      let branchName = this.addBranchNameToSalePrices( prices )
      let newData = this.addInfoForm(event,branchName)
      //console.log(newData ,'newData ')
      if(! this.repeatQuantity(newData) ){
        this.formDataTable.whole_sale_selected.push(...newData)
        this.resetForm()
      }
      else{
        this.setSnackbar({
                type: 'error',
                title: 'Error',
                message: 'Cantidad descuento ya ingresada',
                timeout: 3000,
            })
      }
      
      
    },
    /*
     */
    repeatQuantity(newData){
      let newQuantityArr =  newData.map(d=>d.quantity_discount)
      let currentQuantity  = Array.from(this.formDataTable.whole_sale_selected.map(c=>c.quantity_discount))
      let repeat = false
      if (currentQuantity ===[]) false

      for(let i = 0; i<newQuantityArr.length ; i++){
        if(currentQuantity.includes(newQuantityArr[i])){
          repeat = true
        }
      }

      return repeat
    },
    /*
     */
    getBranchPrices(idBranch){
      
      if (! this.product) return []
      const auxProduct = {...this.product}
      let salesPrices = []
      if(idBranch===0){
        salesPrices = [...auxProduct.sale_prices]
      }
      else{
        salesPrices.push(auxProduct.sale_prices.find(p=>p.branch_office_id === idBranch))
      }
      return salesPrices
    },
    /*
     */
    addBranchNameToSalePrices(salesPrices){
      const  auxProduct = {...this.product}
      salesPrices.forEach(sp=>{
        sp.name =  auxProduct.branch_offices.find(b=>b.g_branch_office_id === sp.branch_office_id).g_branch_office.name  
      })
      return salesPrices
    },
    /*
     */
    addInfoForm(info, branchName){
      const auxBranchName = Array.from(branchName) 
      //console.log(info,'infoBranchName')
      let branch = []
      let collect = []
      for(let i=0; i<auxBranchName.length; i++){
        let newdiscount = {}
        newdiscount.quantity_discount = info.quantity_discount
        newdiscount.unit_price_discount = info.new_price //unique field in price
        newdiscount.percentage_discount = info.new_percentage 
        newdiscount.discount = auxBranchName[i].sale_price-info.new_price //unique field in price
        newdiscount.name = auxBranchName[i].name
        newdiscount.sale_price = auxBranchName[i].sale_price
        newdiscount.branch_office_id = auxBranchName[i].branch_office_id
        newdiscount.new_price_from_percentage = Math.round(auxBranchName[i].sale_price * (1-(info.new_percentage/100)))
        newdiscount.id = Math.random()
        collect.push(newdiscount)
      }
      return collect
      
    },
    /*
     */
    submitWholeSale2(event){
      if(event.whole_sale_selected.length > 0 ){
        let arrPromises = []
        this.loading = true
        event.whole_sale_selected.forEach(e=>{
          //console.log(e,'whole_sale_selected')
          let data = {}
          data.wh_product_id = this.product.id
          data.g_branch_office_id = e.branch_office_id
          data.discount_schema=[
            {
              quantity_discount:e.quantity_discount,
              percentage_discount:e.percentage_discount || 0,
              unit_price_discount:e.unit_price_discount || 0,
            }
          ]
          //console.log(data,'data for submit')
          if(e.updated===true){ //updated row
            let model = new SlWholesaleDiscount({id: this.product.id})
            arrPromises.push(model.sync(data))
          }
          else{ //create row
            arrPromises.push( new SlWholesaleDiscount(data).save() )
          }
        }) 

        Promise.all(arrPromises).then(r=>{
          //snackbar success!!
          //console.log(r,'response shit')
          this.loading = false
          this.setSnackbar({
                type: 'success',
                title: 'Éxito',
                message: 'Descuentos Productos Guardados.',
                timeout: 3000,
            })
        })
        .catch(e=>{
          console.log(e,'error')
        })
      }
    },
    submitWholeSale(event){
      if(event.whole_sale_selected.length > 0 ){
        let arrPromises = []
        this.loading = true
        this.$refs.formTable.setWait = true
        let branchForUpdate = this.arrUpdatedDiscount()
        event.whole_sale_selected.forEach(e=>{
          //console.log(e , 'row e')
          let data = {}
          data.wh_product_id = this.product.id
          data.g_branch_office_id = e.branch_office_id

          if(this.discountTypeRadio ==='price'){
            data.discount_schema=[
              {
                id: e.id,
                quantity_discount:e.quantity_discount,
                percentage_discount: 0,
                unit_price_discount: Math.abs(e.discount) || 0,
              }
            ]
          }
          else if(this.discountTypeRadio === 'percentage' ){
            data.discount_schema=[
              {
                id: e.id,
                quantity_discount:e.quantity_discount,
                percentage_discount:e.percentage_discount || 0,
                unit_price_discount: 0,
              }
            ]
          }
          
          
          if(e.updated===true){ //updated row
            let index = branchForUpdate.findIndex(br=>br.g_branch_office_id === e.branch_office_id)
            branchForUpdate[index].discount_schema.push(...data.discount_schema)
            // let model = new SlWholesaleDiscount({id: this.product.id})
            // arrPromises.push(model.sync(data))
          }
          else{ //create row
            arrPromises.push( new SlWholesaleDiscount(data).save() )
          }
        }) 
        //console.log(this.discountTypeRadio,'type discount current')
        //console.log(branchForUpdate,'all updated')
        branchForUpdate.forEach(b=>{
          if(b.discount_schema.length >0 ){
            let model = new SlWholesaleDiscount({id: this.product.id})
            arrPromises.push(model.sync(b))
          }
        })

        Promise.all(arrPromises).then(r=>{
          //snackbar success!!
          //console.log(r,'response shit')
          this.$refs.formTable.setWait = false
          this.loading = false
          this.$emit('update_table')
          this.setSnackbar({
                type: 'success',
                title: 'Éxito',
                message: 'Descuentos Productos Guardados.',
                timeout: 3000,
            })
        })
        .catch(e=>{
          this.$refs.formTable.setWait = false
          console.log(e,'error')
        })
      }
    },
    /*
     */
    setDataFromDb(product){
      //console.log(product,'product')
      this.formDataTable.whole_sale_selected = []

      product.sl_wholesale_discounts.sort((a,b)=>(a.quantity_discount > b.quantity_discount)? 1: -1)
      
      product.sl_wholesale_discounts.forEach(e =>{
        
        let prices = this.getBranchPrices(e.g_branch_office_id)
        let branchName = this.addBranchNameToSalePrices( prices )
        let newData = this.addInfoDiscount(e,branchName)
        
        this.formDataTable.whole_sale_selected.push(...newData)
      })
      
      // let newData = this.addInfoForm(event,branchName)
      // console.log(newData ,'newData ')
      // this.formDataTable.whole_sale_selected.push(...newData)
    },
    /*
     */
    addInfoDiscount(info,partialData){
      
      let arrAllData = []
      for(let i=0; i<partialData.length; i++){  
        //console.log(partialData[i],'partialdata')
        //console.log(info,'info')
        let infoDiscount ={
        ...partialData[i],
        new_price_from_percentage: Math.round(partialData[i].sale_price * (1-(info.percentage_discount/100))),
        percentage_discount : info.percentage_discount,
        quantity_discount : info.quantity_discount ,
        unit_price_discount: partialData[i].sale_price-parseInt(info.unit_price_discount) ,
        discount : info.unit_price_discount ,
        id: info.id,
        updated:true,
        }
        arrAllData.push(infoDiscount)
      }
      return arrAllData
    },
    /*
     */
    arrUpdatedDiscount(){
      let availableBranch = this.branchAvailable.filter(b=> b.id !== 0)
      return availableBranch.map(ab=>{
        let newArr = {}
        newArr.g_branch_office_id = ab.id
        newArr.discount_schema = []
        return newArr
      })
    },
    /*
    */
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
    removedSaleDiscountTable(event){
      if(event.length===0) return 
      let arrPromises = []
      event.forEach( discount =>{
        this.loading = true
        let route = process.env.VUE_APP_API_ROUTE + "/sl_wholesale_discount/"+discount.id
        
        arrPromises.push( axios.delete(route))
      })

      Promise.all(arrPromises).then(r=>{
          //snackbar success!!
          //console.log(r,'response delete shit')
          this.loading = false
          this.$emit('update_table')
          this.setSnackbar({
                type: 'success',
                title: 'Éxito',
                message: 'Descuentos seleccionados eliminados',
                timeout: 3000,
            })
        })
        .catch(e=>{
          
          console.log(e,'error')
        })
      
    },
    /*
     */
    concatPricesToBranchOffices(product){
      this.branchAvailable.map(br=>{
        let price = product.sale_prices.find(sp=> sp.branch_office_id === br.id)
        
        if(price){
          //console.log(TextFormatting.filters.mixThousandSeparatorFormat(price.sale_price))
          br.name = br.auxName +' - '+ " $"+ TextFormatting.filters.mixThousandSeparatorFormat(price.sale_price)
        }
        return br
      })
    },
    /*
    */
    resetForm(){
      if(! this.formData ) return 
        this.formData = {}
        this.$refs.form.$refs.form.resetValidation()
    },
    // -- Other functions
    // -- Vuex mappings
  },
  watch: {
    // formData:{
    //   handler(val){
    //     console.log(val,'formdata')
    //     if(val.type_discount===true){
    //       this.formFields = fields(this.branchAvailable,val.type_discount)
    //     }
    //     else{
    //       this.formFields = fields(this.branchAvailable, false)
    //     }
    //   },  
    //   deep:true,
    // }
    discountTypeRadio(val){
      if(val === 'price'){
        this.formFields = fields(this.branchAvailable)
        this.formFieldsTable = fieldsTable('price')
      }
      else if( val === 'percentage'){
        this.formFields = fieldsPercentage(this.branchAvailable)
        this.formFieldsTable = fieldsTable('percentage')
      }
    },
    /*
     */
    product(val){
      if(val){
        //console.log(val.type_wholesale_discount)
        //console.log(val,'product') 
        this.setDataFromDb(val)
        this.concatPricesToBranchOffices(val)
        switch (val.type_wholesale_discount) {
          case "$":
            this.formFields = fields(this.branchAvailable)
            this.formFieldsTable = fieldsTable('price')
            this.discountTypeRadio = 'price'
            this.allowDiscountType = false
            break;
          case "%":
            this.formFields = fieldsPercentage(this.branchAvailable)
            this.formFieldsTable = fieldsTable('percentage')
            this.discountTypeRadio = 'percentage'
            this.allowDiscountType = false
            break;
          default:
            this.formFields = fields(this.branchAvailable)
            this.formFieldsTable = fieldsTable('price')
            this.allowDiscountType = true
            break;
        }

      }
    },
    
  },
  components: {
    ModelForm,
    LoadingDialog,
  },
  mixins: [TextFormatting],
  // filters: {},
  // -- Lifecycle Methods
  beforeMount: async function() {
        
    let branch = await BranchOfficeService.fetchAll()
    //   ///this.officeList = 
    // this.formData.branch_office_id.items = branch
    let auxBranch = [
      {id:0, name: 'Todas'},
      ...branch
    ]
    this.branchAvailable = auxBranch.map(ab=>{
      let newObj ={...ab}
      newObj.auxName = ab.name
      return newObj
    })
    //this.formDataTable.whole_sale_selected = []
    

    // this.formDataTable.whole_sale_selected.push(...this.arrTest2)
    // this.formDataTable.whole_sale_selected.push(...this.arrTest1)
      
  },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  .loadingClass{
    margin-top: -35px;
  }
</style>